<div class="main-content customer-cc-report-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card customer-cc-report-card">
					<div class="card-header card-header-{{ color }}-6">
						<h4 class="card-title">
							<i class="material-icons customer-cc-report-back" (click)="back()">arrow_back</i>
							Customers with Credit Cards on Account
						</h4>
						<p class="card-category text-right mb-0">AR customers with saved payment cards (all matching branches)</p>
					</div>
					<div class="card-body" *ngIf="accessDenied">
						<p class="text-muted mb-0">This report is available to managers and administrators only.</p>
					</div>
					<div class="card-body" *ngIf="!accessDenied">
						<section class="customer-cc-filters" aria-label="Report filters">
							<div class="customer-cc-filters__head">
								<span class="customer-cc-filters__title">Filters</span>
								<span class="customer-cc-filters__hint">Optional location, branch, or customer search</span>
							</div>
							<form (ngSubmit)="$event.preventDefault(); runReport()">
								<div class="row g-3">
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Location</mat-label>
											<mat-select [formControl]="locationRef">
												<mat-option value="">All locations</mat-option>
												<mat-option *ngFor="let l of locations" [value]="l.loccode">
													{{ l.locationname }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Branch code</mat-label>
											<input matInput [formControl]="branchRef" placeholder="e.g. 01" />
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Customer</mat-label>
											<input matInput [formControl]="customerInfoRef" placeholder="Account # or name" />
										</mat-form-field>
									</div>
									<div class="col-12 d-flex flex-wrap gap-2 align-items-center">
										<button mat-raised-button color="primary" type="submit" [disabled]="sending">
											Run report
										</button>
										<button mat-stroked-button type="button" (click)="exportXls()" [disabled]="sending || !dataSource.data.length">
											Export Excel
										</button>
										<span class="text-muted ms-2" *ngIf="sending">Loading…</span>
									</div>
								</div>
							</form>
						</section>

						<div class="customer-cc-summary mt-3" *ngIf="totals">
							<span><strong>{{ totals.cardCount }}</strong> cards</span>
							<span class="mx-2">·</span>
							<span><strong>{{ totals.distinctCustomerBranches }}</strong> customer branches</span>
							<span class="text-muted ms-2" *ngIf="getReportSubtitle()">{{ getReportSubtitle() }}</span>
						</div>

						<div class="table-responsive mt-3" *ngIf="dataSource.data.length">
							<table mat-table [dataSource]="dataSource" matSort class="w-100">
								<ng-container matColumnDef="accountNumber">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Account #</th>
									<td mat-cell *matCellDef="let row">{{ row.accountNumber }}</td>
								</ng-container>
								<ng-container matColumnDef="customerName">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
									<td mat-cell *matCellDef="let row">{{ row.customerName }}</td>
								</ng-container>
								<ng-container matColumnDef="branchcode">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Branch</th>
									<td mat-cell *matCellDef="let row">{{ row.branchcode }}</td>
								</ng-container>
								<ng-container matColumnDef="branchName">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Branch name</th>
									<td mat-cell *matCellDef="let row">{{ row.branchName }}</td>
								</ng-container>
								<ng-container matColumnDef="locationName">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
									<td mat-cell *matCellDef="let row">{{ row.locationName || row.locationCode }}</td>
								</ng-container>
								<ng-container matColumnDef="cardType">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Card type</th>
									<td mat-cell *matCellDef="let row">{{ row.cardType }}</td>
								</ng-container>
								<ng-container matColumnDef="maskedNumber">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Card number</th>
									<td mat-cell *matCellDef="let row">{{ row.maskedNumber }}</td>
								</ng-container>
								<ng-container matColumnDef="expiry">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Expiry</th>
									<td mat-cell *matCellDef="let row">{{ row.expiry }}</td>
								</ng-container>
								<ng-container matColumnDef="salesman">
									<th mat-header-cell *matHeaderCellDef mat-sort-header>Salesperson</th>
									<td mat-cell *matCellDef="let row">{{ row.salesman }}</td>
								</ng-container>

								<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
								<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
							</table>
						</div>

						<p class="text-muted mt-3 mb-0" *ngIf="reportCriteria && !sending && !dataSource.data.length">
							No saved cards found for the selected filters.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
